'use strict';

function squaredEuclidean(p, q) {
    var d = 0;
    for (var i = 0; i < p.length; i++) {
        d += (p[i] - q[i]) * (p[i] - q[i]);
    }
    return d;
}

function euclidean(p, q) {
    return Math.sqrt(squaredEuclidean(p, q));
}

module.exports = euclidean;
euclidean.squared = squaredEuclidean;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-hclust/~/ml-euclidean-distance/euclidean.js
 ** module id = 134
 ** module chunks = 0
 **/